import { FC } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CLIENTS_SAY_VALUES } from "./constants";
import classes from "./index.module.css";
import ClientsSayItem from "./ClientsSayItem";

interface ClientsSaySliderProps {
  isMobile: boolean;
  initialSlide: number;
  inactiveDotIsGrey?: boolean;
}

const ClientsSaySlider: FC<ClientsSaySliderProps> = ({
  isMobile,
  initialSlide,
  inactiveDotIsGrey = true,
}) => {
  const sanitizedInitialSlide = Number.isFinite(initialSlide)
    ? Math.max(0, Math.floor(initialSlide))
    : 0;

  const sliderSettings = {
    dots: true,
    arrows: false,
    dotsClass: inactiveDotIsGrey
      ? classes.button__bar__var1
      : classes.button__bar__var2,
    className: classes.customCarouselContainer,
    // Fractional `slidesToShow` + `infinite` can expose cloned slides on the left.
    // Disable infinite on mobile to ensure the "peek" is always the next card (right side).
    infinite: !isMobile,
    rtl: false,
    speed: 500,
    variableWidth: isMobile,
    swipeToSlide: isMobile,
    slidesToShow: isMobile ? 1 : 3,
    slidesToScroll: 1,
    initialSlide: sanitizedInitialSlide,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          variableWidth: true,
          swipeToSlide: true,
          slidesToShow: 1,
          dots: true,
          infinite: false,
          rtl: false,
        },
      },
    ],
  };

  return (
    <>
      <Slider {...sliderSettings}>
        {CLIENTS_SAY_VALUES.map((client) => (
          <ClientsSayItem
            key={client.id}
            alt={`${client.name}, ${client.description}`}
            isMobile={isMobile}
            {...client}
          />
        ))}
      </Slider>
    </>
  );
};

export default ClientsSaySlider;
